import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import { Formik, FieldArray } from "formik";
import {
    AUTHOR_ENTITY_TYPE
} from "../../../constants/cms";
import { useDispatch } from "react-redux";
import {
    getEntitySearchList, clearEntitySearchListResponse,
    getLocationData, getUserData,
} from "../../../../store/slices/authorProfile"
import { Link, useLocation } from 'react-router-dom'
import "../../../assets/css/cms/author.css"

export const LATEST_WRITINGS = {
    entity_type: "",
    entity_search: "",
    order: "",
};

const ManageAuthorForm = (props) => {
    const dispatch = useDispatch();
    const [debounceState, setDebounceState] = useState(false)

    const handleUserSearch = (data) => {
        if (data?.length > 0) {
            let inDebounce = debounceState;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => {
                if (data && data.length > 0) {
                    let params = {};
                    params.filter_type = "author_username";
                    params.term = data
                    dispatch(getUserData(params));
                }
            }, 1000);
            setDebounceState(inDebounce);
        }
    };

    const handleEntitySearch = (data, type) => {
        if (data?.length > 0) {
            let inDebounce = debounceState;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => {
                if (data && data.length > 0) {
                    let params = {};
                    params.filter_type = "latest_data";
                    params.term = data
                    params.entity_type = type?.label == "News" ? "news_domain" : "articles"
                    dispatch(getEntitySearchList(params));
                }
            }, 1000);
            setDebounceState(inDebounce);
        }
    };

    const handleLocationSearch = (data) => {
        if (data?.length > 0) {
            let inDebounce = debounceState;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => {
                if (data && data.length > 0) {
                    let params = {};
                    params.filter_type = "location";
                    params.term = data
                    dispatch(getLocationData(params));
                }
            }, 1000);
            setDebounceState(inDebounce);
        }
    };

    // Adding Permission for managing Author Page Status
    const authorPageStatusPermission = () => {
        let authorized = false;
        const userPermissions = props.userPermission?.data;

        if (userPermissions) {
            authorized = userPermissions.some(permission => {
                return permission.content_type === "author_admin" && permission.name === "Page status";
            });
        }
        return authorized;
    }

    const isAuthorActive=props?.authorData?.author_profile_data?.author_active
   const isMandatory= isAuthorActive? '*' :null

    return (
        <div className={"manage_access"}>
            <Formik
                initialValues={props.initialValues}
                validate={(values) => {
                    let errors = {};
                    if (!(/^(ftp|http|https):\/\/[^ "]+$/.test(values.linkedin)) && values.linkedin) {
                        errors.linkedin = "Enter Valid Url";
                    }
                    if (!(/^(ftp|http|https):\/\/[^ "]+$/.test(values.facebook)) && values.facebook) {
                        errors.facebook = "Enter Valid Url";
                    }
                    if (!(/^(ftp|http|https):\/\/[^ "]+$/.test(values.twitter)) && values.twitter) {
                        errors.twitter = "Enter Valid Url";
                    }
                    if (!(/^(ftp|http|https):\/\/[^ "]+$/.test(values.instagram)) && values.instagram) {
                        errors.instagram = "Enter Valid Url";
                    }

                    if (!values.author_about) {
                        errors.author_about = "Author about is required";
                    }
                    if (!values.author_name) {
                        errors.author_name = "Display Name is required";
                    }

                    if(isAuthorActive){
                        
                        if (!values.designation) {
                            errors.designation = "Designation is required";
                        }
                        if (!values.experience) {
                            errors.experience = "Experience is required";
                        }
                        if (!values.education) {
                            errors.education = "Education is required";
                        }
                        if (!values.author_location) {
                            errors.author_location = "Author location is required";
                        }
                        if (!values.linkedin) {
                            errors.linkedin = "LinkedIn is required";
                        }
                       
                        
                        if (!values.profile_image) {
                            errors.profile_image = "Profile Picture is required";
                        }
                    }
                    if (values.status) {
                        if (authorPageStatusPermission() && !values.author_type?.article && !values.author_type?.news) {
                            errors.author_type = "Required";
                        }
                        if (authorPageStatusPermission() && !values.domain) {
                            errors.domain = "Required";
                        }
                    }
                    const encounteredOrders = {};
                    values.latest_writings?.forEach((entity, index) => {
                        // Check for duplicate orders
                        if (encounteredOrders[entity.order]) {
                            errors.latest_writings ??= [];
                            errors.latest_writings[index] ??= {};
                            errors.latest_writings[index].order = "Weightage must be unique";
                        } else {
                            encounteredOrders[entity.order] = true;
                        }
                    })

                    if (props.id) {
                        return errors;
                    }
                }}

                enableReinitialize={true}
                onSubmit={(values) => {
                    props.submit(values);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <span className={"news_letter_heading"}>
                                <Link to="/cms/author">Home</Link>
                                {props.id ? " >> Edit Author Profile" : " >> Add Author Profile"}
                            </span>
                            <div className={"basic_details"}>
                                <div className={"examfilter"}>
                                    <h4 className={"examfilter_heading"}>Profile Data</h4>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="entity_data"
                                            >
                                                <Form.Label>Username</Form.Label>
                                                {props.id ?
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="author_email"
                                                        disabled={true}
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `author_email`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.author_email}
                                                    />
                                                    :<Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`author_username`}
                                                        value={
                                                            values.author_username
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `author_username`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) =>
                                                            setFieldValue(
                                                                `author_username`,
                                                                value
                                                            )
                                                        }
                                                        onInputChange={(value) => handleUserSearch(value)}
                                                        options={props.userData || []}
                                                        getOptionLabel={(option) => option.author_username}
                                                        getOptionValue={(option) => option.author_id}
                                                    />}
                                            </Form.Group>
                                        </Col>
                                        {props.id && <><Col md={4}>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="entity_data"
                                            >
                                                <Form.Label>Display Name*</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className={"input_pd"}
                                                    name="author_name"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            `author_name`,
                                                            event.target.value
                                                        )
                                                    }
                                                    }
                                                    onBlur={handleBlur}
                                                    value={values?.author_name}
                                                />
                                                {errors?.author_name && touched?.author_name && (
                                                    <div className="error">{errors?.author_name}</div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                            <Col md={4}>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="entity_data"
                                                >
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        disabled={true}
                                                        className={"input_pd"}
                                                        name="author_email"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `author_email`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.author_email}
                                                    />
                                                </Form.Group>
                                            </Col></>}
                                    </Row>
                                    {props.id && <> <Row>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3" controlId="title">
                                                <Form.Label>Profile Picture{isMandatory}</Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    className="mb-2"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        setFieldValue(
                                                            `profile_image`,
                                                            e.target.files[0]
                                                        );
                                                    }}
                                                />
                                                <span>
                                                    {typeof values.profile_image == "string" && values.profile_image != "" && (
                                                        <a href={values.profile_image} target="_blank">
                                                            {values.profile_image}
                                                        </a>
                                                    )}
                                                </span>
                                                {errors?.profile_image && touched?.profile_image && (
                                                    <div className="error">{errors?.profile_image}</div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3" controlId="title">
                                                <Form.Label>Designation{isMandatory}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className={"input_pd"}
                                                    name="designation"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            `designation`,
                                                            event.target.value
                                                        )
                                                    }
                                                    }
                                                    onBlur={handleBlur}
                                                    value={values?.designation}
                                                />
                                                {errors?.designation && touched?.designation && (
                                                    <div className="error">{errors?.designation}</div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3" controlId="title">
                                                <Form.Label>Experience{isMandatory}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className={"input_pd"}
                                                    name="experience"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            `experience`,
                                                            event.target.value
                                                        )
                                                    }
                                                    }
                                                    onBlur={handleBlur}
                                                    value={values?.experience}
                                                />
                                                {errors?.experience && touched?.experience && (
                                                    <div className="error">{errors?.experience}</div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>Education{isMandatory}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="education"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `education`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.education}
                                                    />
                                                    {errors?.education && touched?.education && (
                                                        <div className="error">{errors?.education}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>Location{isMandatory}</Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`author_location`}
                                                        value={
                                                            values.author_location
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `author_location`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) =>
                                                            setFieldValue(
                                                                `author_location`,
                                                                value
                                                            )
                                                        }
                                                        onInputChange={(value) => handleLocationSearch(value)}
                                                        options={props.locationData || []}
                                                        getOptionLabel={(option) => option.loc_string}
                                                        getOptionValue={(option) => option.id}
                                                        isLoading={props.locationDataLoading}
                                                    />
                                                    {errors?.author_location && touched?.author_location && (
                                                        <div className="error">{errors?.author_location}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>LinkedIn{isMandatory}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="linkedin"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `linkedin`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.linkedin}
                                                    />
                                                    {errors?.linkedin && touched?.linkedin && (
                                                        <div className="error">{errors?.linkedin}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>Facebook</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="facebook"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `facebook`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.facebook}
                                                    />
                                                    {errors?.facebook && touched?.facebook && (
                                                        <div className="error">{errors?.facebook}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>Twitter</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="twitter"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `twitter`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.twitter}
                                                    />
                                                    {errors?.twitter && touched?.twitter && (
                                                        <div className="error">{errors?.twitter}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>Instagram</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="instagram"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `instagram`,
                                                                event.target.value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.instagram}
                                                    />
                                                    {errors?.instagram && touched?.instagram && (
                                                        <div className="error">{errors?.instagram}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Group className="mb-3" controlId="title">
                                                    <Form.Label>About*</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        className={"input_pd"}
                                                        name="author_about"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `author_about`,
                                                                event.target.value
                                                            );
                                                        }}
                                                        onBlur={handleBlur}
                                                        value={values?.author_about}
                                                        rows={4}
                                                        cols={50}
                                                    />
                                                    {errors?.author_about && touched?.author_about && (
                                                        <div className="error">{errors?.author_about}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row></>}

                                    {props?.id && <>
                                        <h4 className={"examfilter_heading mt-5"}>Latest/Special</h4>
                                        <FieldArray name="latest_writings">
                                            {({ remove, push }) => (
                                                <div className={""}>
                                                    {[...(values?.latest_writings || [])]?.map((element, index) => (
                                                        <div className={"mb-5"} key={index}>
                                                            <Row>
                                                                <Col md={3}>
                                                                    <Form.Group
                                                                        className="mb-3"
                                                                        controlId="entity_type"
                                                                    >
                                                                        <Form.Label>Entity Type</Form.Label>
                                                                        <Select
                                                                            className="basic-single"
                                                                            classNamePrefix="select"
                                                                            name={`latest_writings.${index}.entity_type`}
                                                                            isClearable
                                                                            value={
                                                                                values?.latest_writings?.[index]
                                                                                    ?.entity_type
                                                                            }
                                                                            isDisabled={values.content_autofetched ? true : false}
                                                                            onBlur={() => {
                                                                                handleBlur({
                                                                                    target: {
                                                                                        name: `latest_writings.${index}.entity_type`,
                                                                                    },
                                                                                });
                                                                            }}
                                                                            onChange={(value) => {
                                                                                setFieldValue(
                                                                                    `latest_writings.${index}.entity_type`,
                                                                                    value
                                                                                )
                                                                                setFieldValue(
                                                                                    `latest_writings.${index}.entity_search`,
                                                                                    null
                                                                                )
                                                                            }
                                                                            }
                                                                            isSearchable={false}
                                                                            options={AUTHOR_ENTITY_TYPE || []}
                                                                            getOptionLabel={(option) => option.label}
                                                                            getOptionValue={(option) => option.value}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <Form.Group
                                                                        className="mb-3"
                                                                        controlId="entity_search"
                                                                    >
                                                                        <Form.Label>Entity Search</Form.Label>
                                                                        <Select
                                                                            className="basic-single"
                                                                            classNamePrefix="select"
                                                                            name={`latest_writings.${index}.entity_search`}
                                                                            isClearable
                                                                            isDisabled={values?.latest_writings?.[index]
                                                                                ?.entity_type && !values.content_autofetched ? false : true}
                                                                            value={
                                                                                values?.latest_writings?.[index]
                                                                                    ?.entity_search
                                                                            }
                                                                            onBlur={() => {
                                                                                handleBlur({
                                                                                    target: {
                                                                                        name: `latest_writings.${index}.entity_search`,
                                                                                    },
                                                                                });
                                                                            }}
                                                                            onChange={(value) => {
                                                                                dispatch(clearEntitySearchListResponse())
                                                                                setFieldValue(
                                                                                    `latest_writings.${index}.entity_search`,
                                                                                    value
                                                                                )
                                                                            }
                                                                            }
                                                                            onInputChange={(value) => handleEntitySearch(value, values.latest_writings[index]?.entity_type)}
                                                                            options={props.entitySearchListData || []}
                                                                            getOptionLabel={(option) => option.title}
                                                                            getOptionValue={(option) => option.id}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <Form.Group
                                                                        className="mb-3"
                                                                        controlId="category_list"
                                                                    >
                                                                        <div className="weightage_cover">
                                                                            <Form.Label>Weightage</Form.Label>
                                                                            <Form.Control
                                                                                type="number"
                                                                                className={"input_pd"}
                                                                                name={`latest_writings.${index}.order`}
                                                                                disabled={values.content_autofetched ? true : false}
                                                                                onChange={(event) => {
                                                                                    if (event.target.value.length <= 1) {
                                                                                        setFieldValue(
                                                                                            `latest_writings.${index}.order`,
                                                                                            event.target.value
                                                                                        )
                                                                                    }
                                                                                }
                                                                                }
                                                                                onBlur={() => {
                                                                                    handleBlur({
                                                                                        target: {
                                                                                            name: `latest_writings.${index}.order`,
                                                                                        },
                                                                                    });
                                                                                }}
                                                                                value={values?.latest_writings?.[index]
                                                                                    ?.order}
                                                                            />
                                                                            {values?.latest_writings?.[index]?.order && <span onClick={() => setFieldValue(
                                                                                `latest_writings.${index}.order`,
                                                                                ""
                                                                            )}>x</span>}
                                                                        </div>
                                                                        {errors.latest_writings?.[index]?.order &&
                                                                            touched.latest_writings?.[index]?.order && (
                                                                                <div className="error">
                                                                                    {errors.latest_writings?.[index]?.order}
                                                                                </div>
                                                                            )}
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col md={1} className="bottom_right_button_container">
                                                                    <div className={"imageField_fieldArray"}>
                                                                        <div className={"imageField_add"}>
                                                                            {values?.latest_writings && values?.latest_writings?.length > 1 && (
                                                                                <span
                                                                                    className={"imageField_minus_icon"}
                                                                                >
                                                                                    <AiFillMinusSquare
                                                                                        onClick={() => {
                                                                                            if (window.confirm('Are you sure you want to remove?')) {
                                                                                                remove(index);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <div>
                                                                            {index == values?.latest_writings?.length - 1 && values?.latest_writings?.length < 5 &&
                                                                                <button
                                                                                    className={"imageField_add_icon"}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault()
                                                                                        push(LATEST_WRITINGS)
                                                                                    }
                                                                                    }
                                                                                    type="submit"
                                                                                >
                                                                                    <BsFillPlusSquareFill />
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </FieldArray>
                                        <Col sm={6}>
                                            <Form.Group className="mb-3 d-flex" controlId="title">
                                                <div className="me-3">
                                                    <Form.Check
                                                        className="checkbox"
                                                        name="content_autofetched"
                                                        checked={!!values.content_autofetched}
                                                        onChange={(event) => {
                                                            setFieldValue('content_autofetched', event.target.checked);
                                                        }}
                                                        disabled={values.latest_writings?.length > 0 && (!!values.latest_writings[0]?.entity_type || !!values.latest_writings[0]?.entity_search || !!values.latest_writings[0]?.order)}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                                <Form.Label>Auto-fetch 5 latest writings</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col sm={6} className="mt-4">
                                                <Form.Label>Author Status</Form.Label>
                                                <Form.Group className="mb-3 d-flex" controlId="title">
                                                    <div className="me-3">
                                                        <Form.Check
                                                            className={"checkbox"}
                                                            disabled={true}
                                                            name={`author_active`}
                                                            checked={values.author_active}
                                                            onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    <Form.Label>Active</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Label>Page Status</Form.Label>
                                                <Form.Group className="mb-3 d-flex" controlId="title">
                                                    <div className="me-3">
                                                        <Form.Check
                                                            className={"checkbox"}
                                                            name={`status`}
                                                            checked={values.status}
                                                            onChange={(event) => {
                                                                if (authorPageStatusPermission()) {
                                                                    setFieldValue(
                                                                        `status`,
                                                                        event.target.checked
                                                                    )
                                                                } else {
                                                                    alert("You Don't have permission to unpublish this page.")
                                                                }
                                                            }
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                    </div>
                                                    <Form.Label>Active</Form.Label>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <div className="author_cover">
                                                <div>
                                                    <Form.Label>Author Type</Form.Label>
                                                    {errors?.author_type && touched?.author_type && (
                                                        <div className="error author_error">{errors?.author_type}</div>
                                                    )}
                                                </div>
                                                <div>
                                                    <Form.Group className="mb-3 d-flex" controlId="author_type.article">
                                                        <div className="me-3">
                                                            <Form.Check
                                                                className="checkbox"
                                                                name={`author_type.article`}
                                                                checked={values.author_type?.article ? true : false}
                                                                onChange={(event) => {
                                                                    if (authorPageStatusPermission()) {
                                                                        setFieldValue(`author_type.article`, event.target.checked);
                                                                    } else {
                                                                        alert("You don't have permission to manage Author Type.");
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                        </div>
                                                        <Form.Label>Article</Form.Label>
                                                    </Form.Group>
                                                </div>
                                                <div>
                                                    <Form.Group className="mb-3 d-flex" controlId="author_type.news">
                                                        <div className="me-3">
                                                            <Form.Check
                                                                className="checkbox"
                                                                name="author_type.news"
                                                                checked={values.author_type?.news ? true : false}
                                                                onChange={(event) => {
                                                                    if (authorPageStatusPermission()) {
                                                                        setFieldValue(`author_type.news`, event.target.checked);
                                                                    } else {
                                                                        alert("You don't have permission to manage Author Type.");
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                        </div>
                                                        <Form.Label>News</Form.Label>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="author_cover">
                                                <div><Form.Label>Publishing Domain</Form.Label>
                                                    {errors?.domain && touched?.domain && (
                                                        <div className="error">{errors?.domain}</div>
                                                    )}
                                                </div>
                                                <div>
                                                    <Form.Group className="mb-3 d-flex" controlId="careers360">
                                                        <div className="me-3">
                                                            <Form.Check
                                                                className={"radio"}
                                                                type="radio"
                                                                name="domain"
                                                                value={1}
                                                                disabled={props.authorData?.author_profile_data?.domain ? true : false}
                                                                checked={values.domain == 1}
                                                                onChange={(event) => {
                                                                    if (authorPageStatusPermission()) {
                                                                        setFieldValue('domain', event.target.value);
                                                                    } else {
                                                                        alert("You don't have permission to to Manage Publishing Domain.");
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                        </div>
                                                        <Form.Label>Careers360</Form.Label>
                                                    </Form.Group>
                                                </div>

                                                <div>
                                                    <Form.Group className="mb-3 d-flex" controlId="news">
                                                        <div className="me-3">
                                                            <Form.Check
                                                                className={"radio"}
                                                                type="radio"
                                                                name="domain"
                                                                value={2}
                                                                disabled={props.authorData?.author_profile_data?.domain ? true : false}
                                                                checked={values.domain == 2}
                                                                onChange={(event) => {
                                                                    if (authorPageStatusPermission()) {
                                                                        setFieldValue('domain', event.target.value);
                                                                    } else {
                                                                        alert("You don't have permission to to Manage Publishing Domain.");
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                        </div>
                                                        <Form.Label>News</Form.Label>
                                                    </Form.Group>
                                                </div>

                                                <div>
                                                    <Form.Group className="mb-3 d-flex" controlId="hindi_news">
                                                        <div className="me-3">
                                                            <Form.Check
                                                                className={"radio"}
                                                                type="radio"
                                                                name="domain"
                                                                value={3}
                                                                disabled={props.authorData?.author_profile_data?.domain ? true : false}
                                                                checked={values.domain == 3}
                                                                onChange={(event) => {
                                                                    if (authorPageStatusPermission()) {
                                                                        setFieldValue('domain', event.target.value);
                                                                    } else {
                                                                        alert("You don't have permission to to Manage Publishing Domain.");
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                        </div>
                                                        <Form.Label>Hindi News</Form.Label>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </Row>
                                    </>
                                    }
                                    <Row>
                                        <Col className="mt-3">
                                            <button
                                                className={`${"exam_button"} ${"save_changes"}`}
                                                type="submit"
                                            >
                                                Save
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </div >
    );
};

export default ManageAuthorForm;